module.exports = __webpack_public_path__ + "static/media/dragontiger.d3f9dc56.png";